export default {
      id: "selectedCluster-usage",
      viewBox: "0 0 76 76",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#selectedCluster",
      toString: function () {
        return this.url;
      }
    }